import { KeyboardEvent, useCallback } from "react";
import { Room } from "@mui/icons-material";
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
  styled,
} from "@mui/material";
import { useEventListener } from "../../hooks/useEventListener";

import { LocationResult, SelectedLocationState } from "../../types";

interface Props {
  item: LocationResult;
  index: number;
  onSelect: (result: LocationResult) => void;
  selected: SelectedLocationState;
}

export function LocationSearchItem(props: Props) {
  const { item, onSelect, index, selected } = props;
  const onKeyDownHandler = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (
        event.key === "Enter" &&
        selected.selectedIndex === index &&
        selected.selectedItem !== item
      ) {
        onSelect(item);
      }
    },
    [item, selected, index, onSelect]
  );

  useEventListener<(event: KeyboardEvent<HTMLInputElement>) => void>(
    "keyup",
    onKeyDownHandler,
    document
  );

  return (
    <Styles
      selected={
        selected.selectedIndex === index || selected.selectedItem === item
      }
      onClick={() => onSelect(item)}
    >
      <ListItemIcon>
        <Room fontSize="small" className="iconResult" />
      </ListItemIcon>
      <ListItemText>
        <Typography variant="body1" noWrap>
          {item.displayName}
        </Typography>
      </ListItemText>
    </Styles>
  );
}

const Styles = styled(MenuItem)`
  & > .MuiListItemIcon-root {
    min-width: ${({ theme }) => theme.spacing(4)};
  }
`;
